import { render } from "./CatPink.vue?vue&type=template&id=255c0768"
const script = {}
script.render = render

export default script